const PHONE = '743 06 19 91';
const PHONE_DIGITS = PHONE.replace(/\s/g, '');

export const BRAND = Object.freeze({
  phone: PHONE,
  phoneDigits: PHONE_DIGITS,
  phoneHref: `tel:+34${PHONE_DIGITS}`,
  whatsappUrl: `https://wa.me/34${PHONE_DIGITS}`,
  name: 'CG Valet Parking',
  website: 'cgvaletparking.es',
  websiteUrl: process.env.REACT_APP_PUBLIC_SITE_URL,
  contactEmail: 'contacto@cgvaletparking.es',
  bookingEmail: 'reservas@cgvaletparking.es',
  logo: '/brand/cg-valet-parking.png',
  printLogo: '/brand/cg-valet-parking-print.png',
});
